import { API_STATUS, UploadFileSignedUrlResponse } from "@types";
import clog from "../others/clog";
import instance from "./axios";

const uploadSignedUrl = async (
  file: File,
  uploadUrl: string,
): Promise<UploadFileSignedUrlResponse> => {
  try {
    const response = await instance.put(uploadUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });

    clog("Upload response:", response);
    if (response.status !== 200) {
      throw new Error(`Upload failed with status: ${response.statusText}`);
    }

    return { status: API_STATUS.SUCCESS };
  } catch (error) {
    clog("Upload error:", error);
    return { status: API_STATUS.ERROR, error: (error as Error).message };
  }
};

export default uploadSignedUrl;
